/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mcp_Server_Development_Tlm_1Inputs */

const en_svc_mcp_server_development_tlm_1 = /** @type {(inputs: Svc_Mcp_Server_Development_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`auth`)
};

const ar_svc_mcp_server_development_tlm_1 = /** @type {(inputs: Svc_Mcp_Server_Development_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المصادقة`)
};

const bn_svc_mcp_server_development_tlm_1 = /** @type {(inputs: Svc_Mcp_Server_Development_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`auth`)
};

const de_svc_mcp_server_development_tlm_1 = /** @type {(inputs: Svc_Mcp_Server_Development_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auth`)
};

const es_svc_mcp_server_development_tlm_1 = /** @type {(inputs: Svc_Mcp_Server_Development_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`autenticación`)
};

const fr_svc_mcp_server_development_tlm_1 = /** @type {(inputs: Svc_Mcp_Server_Development_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`authentification`)
};

const pt_svc_mcp_server_development_tlm_1 = /** @type {(inputs: Svc_Mcp_Server_Development_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`autenticação`)
};

const zh_svc_mcp_server_development_tlm_1 = /** @type {(inputs: Svc_Mcp_Server_Development_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`授权`)
};

const tr_svc_mcp_server_development_tlm_1 = /** @type {(inputs: Svc_Mcp_Server_Development_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`yetki`)
};

const ru_svc_mcp_server_development_tlm_1 = /** @type {(inputs: Svc_Mcp_Server_Development_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`авторизация`)
};

const pl_svc_mcp_server_development_tlm_1 = /** @type {(inputs: Svc_Mcp_Server_Development_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`autoryzacja`)
};

/**
* | output |
* | --- |
* | "auth" |
*
* @param {Svc_Mcp_Server_Development_Tlm_1Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mcp_server_development_tlm_1 = /** @type {((inputs?: Svc_Mcp_Server_Development_Tlm_1Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mcp_Server_Development_Tlm_1Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mcp_server_development_tlm_1(inputs)
	if (locale === "bn") return bn_svc_mcp_server_development_tlm_1(inputs)
	if (locale === "de") return de_svc_mcp_server_development_tlm_1(inputs)
	if (locale === "es") return es_svc_mcp_server_development_tlm_1(inputs)
	if (locale === "fr") return fr_svc_mcp_server_development_tlm_1(inputs)
	if (locale === "pt") return pt_svc_mcp_server_development_tlm_1(inputs)
	if (locale === "zh") return zh_svc_mcp_server_development_tlm_1(inputs)
	if (locale === "tr") return tr_svc_mcp_server_development_tlm_1(inputs)
	if (locale === "ru") return ru_svc_mcp_server_development_tlm_1(inputs)
	if (locale === "pl") return pl_svc_mcp_server_development_tlm_1(inputs)
	return en_svc_mcp_server_development_tlm_1(inputs)
});
export { svc_mcp_server_development_tlm_1 as "svc_mcp-server-development_tlm_1" }